var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7089906C-C819-4588-9932-0E6CBE75D31D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Paperless-\\u2013-Digital-reception-\\u2013-v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Damage-report-overview-\\u2013-collapsed-\\u2013-Private-flow-\\u2013-Paperless-\\u2013-Digital-reception-\\u2013-v4",
    transform: "translate(-312.000000, -231.000000)",
    fill: "#6B6E85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Damage-description",
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(312.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0261546,2.59238712 L15.4032506,3.96948313 C16.1842992,4.75053172 16.1842992,6.01686168 15.4032506,6.79791026 L4.49933715,17.7018237 C4.31228595,17.8888749 4.05874047,17.9941911 3.79421065,17.994715 L1.01216926,18.0002242 C0.460077923,18.0008223 0.0115576578,17.5542961 0.00969592844,17.0022075 L0.00276960432,14.2040369 C0.00211099134,13.9379634 0.107516789,13.6825978 0.29565976,13.4944548 L11.1977275,2.59238712 C11.978776,1.81133854 13.245106,1.81133854 14.0261546,2.59238712 Z M8.852,7.742 L2.39991449,14.1940591 C2.21078498,14.3831886 2.10530393,14.6402017 2.1070424,14.9076655 L2.1070424,14.9076655 L2.11024221,15.3999588 C2.11224948,15.6760108 2.3374274,15.8983751 2.61348282,15.8969114 L2.61348282,15.8969114 L3.09551394,15.8939835 C3.35862149,15.8923854 3.61049835,15.7871573 3.79654691,15.6011088 L3.79654691,15.6011088 L10.253,9.143 L8.852,7.742 Z M13.3137461,4.68206849 C12.9266384,4.29496078 12.2990128,4.29496078 11.9119051,4.68206849 L11.9119051,4.68206849 L10.253,6.341 L11.654,7.742 L13.3137461,6.08390954 C13.6710763,5.72657934 13.6985633,5.16431081 13.396207,4.77545164 Z",
    id: "px-pencil"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxPencil);
export default __webpack_public_path__ + "static/media/px-pencil.24e5713b39ce354bc085fcce11d78f5a.svg";
export { ForwardRef as ReactComponent };